import React from 'react';
export function LegalFooter() {
  return <footer className="bg-forest text-white/70 py-12" data-id="element-91">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        <div className="mb-8" data-id="element-93">
          <h3 className="text-white font-semibold mb-4" data-id="element-94">
            Aviso Legal y Descargo de Responsabilidad
          </h3>
          <p className="text-sm leading-relaxed" data-id="element-95">
            Este producto, "Metabolismo Silver 21", tiene un propósito puramente
            informativo y educativo. El contenido aquí presentado no pretende
            sustituir el consejo, diagnóstico o tratamiento médico profesional.
            Siempre busque el consejo de su médico u otro proveedor de salud
            calificado antes de iniciar cualquier dieta, programa de ejercicio o
            cambio en su estilo de vida, especialmente si tiene condiciones
            preexistentes. El autor no se hace responsable de las decisiones
            tomadas por el lector basadas en la información de este libro. El
            uso de la información contenida en esta guía es bajo su propio
            riesgo y responsabilidad.
          </p>
        </div>
        <div className="border-t border-white/10 pt-8 text-center text-sm" data-id="element-96">
          <p data-id="element-97">© 2024 Metabolismo Silver 21. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}